module.exports = __webpack_public_path__ + "img/flag.bd3a87be.svg";